import {getLocalizationBasedOnLang} from '../../data/models/User/UserInfo';

const english = {
  previewMode: 'You are in preview mode',
  course: 'Course name: ',
  microreel: 'Microreel name: ',
};

const welsh = {
  previewMode: 'Rydych chi mewn modd rhagolwg',
  course: "Enw 'r cwrs",
  microreel: "Enw 'r microreel: ",
};

export const videoPlaybackText = getLocalizationBasedOnLang(english, welsh);
